import { ethers } from 'ethers';
import { CHAINS } from '../config/chains';

/**
 * Check if user has any fee token balance on Tempo
 * Tempo allows using PathUSD, AlphaUSD, BetaUSD, or ThetaUSD as fee tokens
 * @param {ethers.providers.Provider} provider - Ethers provider
 * @param {string} userAccount - User's wallet address
 * @returns {Promise<{hasFeeToken: boolean, feeTokenBalance: string, feeTokenSymbol: string}>}
 */
export async function checkTempoFeeTokenBalance(provider, userAccount) {
    const tempoChain = CHAINS.tempo;
    
    if (!tempoChain || !tempoChain.feeTokens || tempoChain.feeTokens.length === 0) {
        // Not Tempo or no fee tokens configured, return default
        return {
            hasFeeToken: false,
            feeTokenBalance: '0',
            feeTokenSymbol: null
        };
    }

    // Check balance for each fee token
    const tokenABI = ['function balanceOf(address) view returns (uint256)'];
    
    for (const feeToken of tempoChain.feeTokens) {
        try {
            const tokenContract = new ethers.Contract(
                feeToken.address,
                tokenABI,
                provider
            );
            const balance = await tokenContract.balanceOf(userAccount);
            
            // If user has any balance in this fee token, they can pay fees
            if (!balance.isZero()) {
                const formattedBalance = ethers.utils.formatUnits(balance, feeToken.decimals || 6);
                return {
                    hasFeeToken: true,
                    feeTokenBalance: formattedBalance,
                    feeTokenSymbol: feeToken.symbol
                };
            }
        } catch (error) {
            console.error(`Error checking ${feeToken.symbol} balance:`, error);
            // Continue to next token
        }
    }

    // No fee tokens found with balance
    return {
        hasFeeToken: false,
        feeTokenBalance: '0',
        feeTokenSymbol: null
    };
}

/**
 * Get all fee token symbols for Tempo (for display purposes)
 * @returns {string[]} Array of fee token symbols
 */
export function getTempoFeeTokenSymbols() {
    const tempoChain = CHAINS.tempo;
    if (!tempoChain || !tempoChain.feeTokens) {
        return [];
    }
    return tempoChain.feeTokens.map(token => token.symbol);
}




